var map = {
	"./hk/scripts/components/setting.json": 854,
	"./in/scripts/components/setting.json": 855,
	"./kr/scripts/components/setting.json": 856,
	"./sg/scripts/components/setting.json": 857,
	"./tw/scripts/components/setting.json": 858
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;


//////////////////
// WEBPACK FOOTER
// ./src/assets/src ^\.\/.*\/scripts\/components\/setting\.json$
// module id = 473
// module chunks = 0 1 2 3 4 5